import {getVPCServiceWithoutSlash} from "../App/utils";

export const PIPE_API_BASE_URL = getVPCServiceWithoutSlash('pipe') || 'https://pipe.openkbs.com'; // "error":"job failed (502)"
